
export const faqCategories = [
  { id: 'all', label: 'All Questions', icon: 'ri-list-check' },
  { id: 'pricing', label: 'Pricing & Costs', icon: 'ri-money-dollar-circle-line' },
  { id: 'services', label: 'Services & Application', icon: 'ri-plant-line' },
  { id: 'technology', label: 'Technology & Equipment', icon: 'ri-drone-line' },
  { id: 'safety', label: 'Safety & Compliance', icon: 'ri-shield-check-line' },
  { id: 'scheduling', label: 'Scheduling & Timing', icon: 'ri-calendar-check-line' },
  { id: 'deer', label: 'Deer Deterrent', icon: 'ri-leaf-line' },
  { id: 'getting-started', label: 'Getting Started', icon: 'ri-rocket-line' },
];

export const faqItems = [
  {
    id: 1,
    category: 'pricing',
    question: 'How much does aerial application cost compared to ground spraying?',
    answer: 'Pricing varies based on acreage, product type, and field conditions, but most operations find aerial application competitive with ground spraying when you factor in the hidden costs. Ground equipment destroys 3\u20135% of standing crop per pass\u2014on 1,000 acres of corn at $900/acre gross, that\u2019s $27,000\u2013$45,000 lost every season to wheel traffic alone. When you add compaction damage, rut repair, and missed timing windows, aerial application often comes out ahead on total cost per acre.',
  },
  {
    id: 2,
    category: 'pricing',
    question: 'Do you charge per acre or per application?',
    answer: 'We typically price per acre per application. Rates depend on the product being applied, field size, terrain complexity, and distance from our staging area. Larger operations and multi-application seasonal contracts receive volume pricing. We\u2019ll give you a clear, upfront quote before any work begins\u2014no hidden fees, no surprises.',
  },
  {
    id: 3,
    category: 'pricing',
    question: 'Is there a minimum charge or setup fee?',
    answer: 'There is a minimum acreage requirement of approximately 200 acres for aerial application to be cost-effective. For smaller acreages, we can often coordinate with neighboring farms to meet the minimum. There are no hidden setup fees\u2014our per-acre rate covers mobilization, application, and post-application reporting.',
  },
  {
    id: 4,
    category: 'pricing',
    question: 'Do you offer seasonal contracts or multi-application discounts?',
    answer: 'Yes. Many of our clients book a full-season package that covers multiple applications\u2014typically a spring herbicide pass, mid-season fungicide, and late-season foliar nutrient. Seasonal contracts lock in your pricing and guarantee priority scheduling during peak windows. Most operations save 10\u201315% compared to booking individual applications.',
  },
  {
    id: 5,
    category: 'pricing',
    question: 'What\u2019s the ROI on switching from ground to aerial application?',
    answer: 'The return varies by operation, but here\u2019s a real example: A 2,400-acre corn and soybean operation in Lancaster County saved an estimated $38,000 in the first season by eliminating wheel traffic damage and hitting every spray window on time. Our ROI Calculator on this site can give you a personalized estimate based on your specific acres, crops, and current practices.',
  },
  {
    id: 6,
    category: 'services',
    question: 'What products can you apply with drones?',
    answer: 'We can apply fungicides, herbicides, foliar nutrients, plant growth regulators, cover crop seed, and biological products. Our equipment handles both liquid and granular applications. We work with all major ag chemical brands and can coordinate directly with your agronomist or retailer to ensure proper product handling and application rates.',
  },
  {
    id: 7,
    category: 'services',
    question: 'Can you spray when my fields are too wet for ground equipment?',
    answer: 'Absolutely\u2014this is one of the biggest advantages of aerial application. We can apply when fields are saturated and ground rigs would cause ruts, compaction, or get stuck entirely. This means you don\u2019t miss critical spray windows after rain events. We\u2019ve saved many crops by getting fungicide on during narrow windows when ground equipment simply couldn\u2019t enter the field.',
  },
  {
    id: 8,
    category: 'services',
    question: 'Do you handle my chemicals or do I provide them?',
    answer: 'Either way works. You can provide your own products and we\u2019ll apply them, or we can source products for you through our supplier network. If you have a preferred agronomist or retailer, we\u2019re happy to coordinate directly with them on product selection, rates, and timing. We just need the product on-site or delivered to our staging area before the application window.',
  },
  {
    id: 9,
    category: 'services',
    question: 'What crops do you work with?',
    answer: 'We primarily serve row-crop operations\u2014corn, soybeans, wheat, barley, and sorghum are our core focus. We also work with specialty crops, hay fields, and pastureland for specific applications. If you\u2019re growing something we haven\u2019t listed, just ask. Chances are we\u2019ve worked with it or can adapt our approach.',
  },
  {
    id: 10,
    category: 'services',
    question: 'Do you offer cover crop seeding?',
    answer: 'Yes. Aerial cover crop seeding is one of our most popular services. We can seed into standing crops before harvest, which gives the cover crop a head start and eliminates the need for a separate field pass. We handle cereal rye, crimson clover, radishes, and custom mixes. Seeding rates are calibrated precisely using GPS guidance for uniform coverage.',
  },
  {
    id: 11,
    category: 'services',
    question: 'Can you do variable-rate application?',
    answer: 'Yes. Our equipment supports variable-rate technology (VRT) using prescription maps from your agronomist or precision ag platform. This means we can adjust application rates across different zones in your field based on soil type, yield data, or scouting reports. Variable-rate application reduces waste, improves efficacy, and puts product exactly where it\u2019s needed most.',
  },
  {
    id: 12,
    category: 'technology',
    question: 'What kind of drones do you use?',
    answer: 'We operate commercial-grade agricultural drones designed specifically for crop application. These are not hobby drones\u2014they\u2019re purpose-built machines with 40\u201360 pound payload capacities, precision GPS guidance, and spray systems engineered for uniform coverage. Our fleet is maintained to manufacturer specifications and inspected before every operation.',
  },
  {
    id: 13,
    category: 'technology',
    question: 'How accurate is drone application compared to ground sprayers?',
    answer: 'Our drones use RTK GPS guidance accurate to within 1\u20132 centimeters. Combined with precision nozzle systems and real-time flow monitoring, we achieve application accuracy that matches or exceeds ground equipment. The key difference is consistency\u2014we maintain the same speed, height, and overlap across the entire field without the variability that comes from operator fatigue or terrain changes.',
  },
  {
    id: 14,
    category: 'technology',
    question: 'How do you handle drift control?',
    answer: 'Drift prevention is built into every aspect of our operation. We fly at lower altitudes than traditional aircraft (typically 6\u201310 feet above canopy), which significantly reduces drift potential. We use drift-reducing nozzles, monitor wind speed and direction in real-time, and won\u2019t fly when conditions aren\u2019t right. Buffer zones and sensitive areas are mapped before we start. Your neighbors are often our customers too\u2014we take this seriously.',
  },
  {
    id: 15,
    category: 'technology',
    question: 'Is this actually proven technology or still experimental?',
    answer: 'Agricultural drones have been used commercially for over a decade, with millions of acres treated annually in the US alone. The technology is FAA-certified, and our operators are licensed and insured. We\u2019re not asking you to be an early adopter\u2014we\u2019re offering proven equipment and methods that are already delivering results for operations across the Mid-Atlantic region and beyond.',
  },
  {
    id: 16,
    category: 'technology',
    question: 'What happens if a drone malfunctions during application?',
    answer: 'Our drones have multiple redundancy systems including backup GPS, redundant motors, and automatic return-to-home failsafes. If a system detects any anomaly, the drone will safely land or return to the staging area. We always have backup equipment on-site during operations. In over thousands of hours of flight time, equipment issues have never resulted in crop damage or incomplete applications.',
  },
  {
    id: 17,
    category: 'technology',
    question: 'Can your drones handle hilly or uneven terrain?',
    answer: 'Yes. Our terrain-following radar automatically adjusts flight altitude to maintain consistent height above the crop canopy, even on rolling hills and uneven ground. This is actually an advantage over ground equipment, which can struggle with steep grades, waterways, and irregular field shapes. We\u2019ve successfully operated on terrain that would be difficult or impossible for ground rigs.',
  },
  {
    id: 18,
    category: 'safety',
    question: 'Are your operators licensed and insured?',
    answer: 'Every operator on our team holds an FAA Part 107 Remote Pilot Certificate and maintains current agricultural application certifications. We carry comprehensive liability insurance that covers aerial application operations. We\u2019re happy to provide certificates of insurance to you or your landlord upon request.',
  },
  {
    id: 19,
    category: 'safety',
    question: 'What about chemical safety and environmental compliance?',
    answer: 'We follow all EPA label requirements, state pesticide regulations, and best management practices for aerial application. Our operators are trained in chemical handling, spill prevention, and environmental protection. We maintain detailed application records including GPS flight logs, product rates, weather conditions, and buffer zone compliance for every job.',
  },
  {
    id: 20,
    category: 'safety',
    question: 'How do you protect neighboring properties and waterways?',
    answer: 'Before every application, we map all sensitive areas including neighboring properties, waterways, wells, organic fields, and bee yards. We program automatic buffer zones into our flight plans\u2014the drone physically will not spray within these zones. Combined with low-altitude application and drift-reducing nozzles, we provide a level of precision that\u2019s difficult to achieve with ground equipment or manned aircraft.',
  },
  {
    id: 21,
    category: 'safety',
    question: 'Do I need to notify my neighbors before you spray?',
    answer: 'We recommend it as a courtesy, and in some areas it may be required by local regulation. We can help you with neighbor notification if needed. Many of our clients\u2019 neighbors end up becoming clients themselves once they see the precision and care we bring to every application.',
  },
  {
    id: 22,
    category: 'safety',
    question: 'What weather conditions will prevent you from flying?',
    answer: 'We won\u2019t fly in winds above 10\u201315 mph (depending on product), during rain, in fog or low visibility, or during temperature inversions that could cause drift. We monitor weather conditions continuously and will postpone if conditions aren\u2019t right. We\u2019d rather reschedule than risk a poor application\u2014your crop and your neighbors\u2019 crops are too important.',
  },
  {
    id: 23,
    category: 'scheduling',
    question: 'How far in advance do I need to book?',
    answer: 'For planned applications (seasonal fungicide, cover crop seeding), we recommend booking 2\u20134 weeks in advance, especially during peak season (June\u2013September). For urgent applications when weather windows open unexpectedly, we maintain rapid-response capacity and can often mobilize within 24\u201348 hours. Seasonal contract clients get priority scheduling.',
  },
  {
    id: 24,
    category: 'scheduling',
    question: 'How quickly can you respond during a narrow spray window?',
    answer: 'During peak season, we maintain crews ready to mobilize within 24\u201348 hours for urgent applications. We understand that a 3-day delay during critical growth stages can cost you $60\u2013$90 per acre in yield loss. That\u2019s why we prioritize responsiveness and maintain the capacity to move quickly when weather windows open up.',
  },
  {
    id: 25,
    category: 'scheduling',
    question: 'What time of day do you typically spray?',
    answer: 'Most applications happen in early morning or late afternoon when wind speeds are lowest and temperatures are most favorable for product efficacy. We avoid midday application during hot weather to reduce evaporation and drift risk. The exact timing depends on the product label requirements, weather forecast, and your field conditions.',
  },
  {
    id: 26,
    category: 'scheduling',
    question: 'How long does it take to spray a typical field?',
    answer: 'Application speed depends on field size, product type, and required rate. As a general guide, we can cover 80\u2013120 acres per hour under normal conditions. A 500-acre field typically takes half a day including setup, calibration, and refills. We\u2019ll give you a time estimate before we start so you can plan accordingly.',
  },
  {
    id: 27,
    category: 'scheduling',
    question: 'What if weather forces a cancellation after I\u2019ve booked?',
    answer: 'Weather cancellations are part of farming\u2014we get it. There\u2019s no cancellation fee for weather-related postponements. We\u2019ll reschedule as quickly as possible, and seasonal contract clients get first priority for rescheduled slots. We monitor forecasts closely and will communicate proactively if we see a potential delay coming.',
  },
  {
    id: 28,
    category: 'deer',
    question: 'How does your deer deterrent program work?',
    answer: 'Our program uses a combination of aerial thermal surveys to identify deer pressure points, targeted deterrent applications along field edges and travel corridors, and ongoing monitoring throughout the growing season. We focus on the areas where deer do the most damage\u2014typically the first 4\u20138 rows on field edges adjacent to wooded areas. Most operations see 50\u201370% reduction in browse damage.',
  },
  {
    id: 29,
    category: 'deer',
    question: 'What deterrent products do you use?',
    answer: 'We use EPA-registered deer repellents that are safe for crops, soil, and waterways. The specific product depends on the crop, growth stage, and severity of deer pressure. We rotate products throughout the season to prevent habituation. All products are applied at label rates and are compatible with your other crop protection inputs.',
  },
  {
    id: 30,
    category: 'deer',
    question: 'How often do you need to reapply deer deterrent?',
    answer: 'Reapplication frequency depends on rainfall, crop growth rate, and deer pressure intensity. Typically, we reapply every 2\u20134 weeks during the active growing season. Heavy rain events may require an additional application. Our monitoring program tracks effectiveness between applications so we can adjust timing as needed.',
  },
  {
    id: 31,
    category: 'deer',
    question: 'Is the deer deterrent program worth the cost?',
    answer: 'For operations with significant deer pressure, absolutely. Edge-row deer damage costs Mid-Atlantic farmers an estimated $800+ per acre annually. Our deterrent program typically costs a fraction of that and delivers 50\u201370% reduction in browse damage. Most clients see a 3\u20135x return on their investment in the first season. We can assess your specific situation and give you an honest estimate of potential savings.',
  },
  {
    id: 32,
    category: 'deer',
    question: 'Can you help with deer damage on food plots or specialty crops?',
    answer: 'Yes. While our primary focus is row-crop protection, we also work with food plot managers, vineyard operators, and specialty crop growers dealing with deer pressure. The approach is similar\u2014thermal surveys to identify patterns, targeted deterrent application, and ongoing monitoring\u2014but we adapt the specific products and timing to your crop type.',
  },
  {
    id: 33,
    category: 'getting-started',
    question: 'How do I know if aerial application makes sense for my operation?',
    answer: 'The best way is to have a conversation. Tell us about your acres, what you\u2019re growing, your biggest challenges, and what you\u2019ve tried before. We\u2019ll give you an honest assessment of whether our services would help. If it\u2019s not a good fit, we\u2019ll tell you. No pressure, no sales pitch\u2014just straight answers about what we can and can\u2019t do for your specific situation.',
  },
  {
    id: 34,
    category: 'getting-started',
    question: 'What\u2019s the minimum acreage you\u2019ll work with?',
    answer: 'We typically work with operations of 200 acres or more for aerial application services. For smaller acreages, we can often coordinate with neighboring farms to make it work. Deer deterrent and land management services have more flexibility on minimum size. Give us a call\u2014we\u2019ll be straight with you about whether it makes sense.',
  },
  {
    id: 35,
    category: 'getting-started',
    question: 'What information do you need from me to get started?',
    answer: 'To give you an accurate quote and plan, we\u2019ll need: your total acreage and field locations, what crops you\u2019re growing, what products you want applied (or what problems you\u2019re trying to solve), your typical spray schedule, and any sensitive areas we should know about. A phone call or field visit is usually the best way to cover everything.',
  },
  {
    id: 36,
    category: 'getting-started',
    question: 'Do you do a field visit before the first application?',
    answer: 'Yes, for new clients we always do an initial field assessment. We\u2019ll walk your fields, identify any obstacles or sensitive areas, discuss your goals and concerns, and develop a customized application plan. This visit is free and comes with no obligation. It\u2019s the best way for both of us to determine if we\u2019re a good fit.',
  },
  {
    id: 37,
    category: 'getting-started',
    question: 'What areas do you serve?',
    answer: 'We primarily serve the Mid-Atlantic region including Pennsylvania, Maryland, Delaware, Virginia, and West Virginia. We\u2019re expanding our coverage area and may be able to accommodate operations outside this region depending on size and timing. If you\u2019re nearby but not sure if we cover your area, just ask.',
  },
  {
    id: 38,
    category: 'getting-started',
    question: 'Can I try a single application before committing to a full season?',
    answer: 'Absolutely. Many of our long-term clients started with a single application to see the results firsthand. There\u2019s no obligation to book a full season. We\u2019d rather earn your business one application at a time than lock you into something you\u2019re not sure about. Most farmers who try it once come back for more.',
  },
];
